module.exports = __webpack_public_path__ + "img/mass_longevity.ddceaf7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mass_longevity.gif
// module id = BGbE
// module chunks = 0